import React, { FC } from 'react';

import { ConfigProvider, Flex, Grid, Typography } from 'antd';

import SecurityIcon from '@/assets/icons/security.svg?react';

import styles from './DataSecurityHelperText.module.scss';

const { useBreakpoint } = Grid;

export const DataSecurityHelperText: FC = () => {
	const screens = useBreakpoint();

	return (
		<ConfigProvider
			theme={{
				components: {
					Typography: {
						fontSize: !screens.md ? 14 : 16,
						lineHeight: 1.25,
						fontFamily: 'Inter, sans-serif',
					},
				},
			}}
		>
			<div className={styles['container']}>
				<SecurityIcon className={styles['icon']} />
				<Flex gap={4} vertical>
					<Typography.Text strong>Your Data Is Safe With Us</Typography.Text>
					<Typography.Text>
						Your privacy is our priority. We never sell your data to third parties.
					</Typography.Text>
				</Flex>
			</div>
		</ConfigProvider>
	);
};
